export default __webpack_public_path__ + "static/media/card-background.5aebcd1b.svg";